export async function fetchreports (userDetails: any) {
  const response = await fetch('/customPortal/customerReports', {
    headers: {
      'Content-Type': 'application/json',
      rt: reversestring(userDetails.e_id)
    },
    method: 'POST',
    body: JSON.stringify(userDetails)
  })
  if (!response.ok || response.status === 204) {
    return response
  }
  return response.json()
}

export function gsspReportDownload (cognosReportData: any): Promise<Response> {
  return fetch('/customPortal/gsspDownload', {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(cognosReportData)
  })
}

export async function getReportPackageDetails (containerId: string) {
  const params = new URLSearchParams({ containerId })
  const response = await fetch(`/customPortal/getReportPackage?${params.toString()}`, {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'GET'
  })
  if (!response.ok || response.status === 204 ) {
    return response
  }
  return response.json()
}

export async function getUserData () {
  const response = await fetch('/customPortal/getUserData', {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'GET'
  })
  if (!response.ok || response.status === 204 ) {
    return response
  }
  return response.json()
}

export async function getProductList () {
  const response = await fetch('/customPortal/getProductList', {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'GET'
  })
  if (!response.ok || response.status === 204 ) {
    return response
  }
  return response.json()
}

export async function updateBookmark (userDetails: any) {
  const response = await fetch('/customPortal/saveBmReports', {
    headers: {
      'Content-Type': 'application/json',
      rt: reversestring(userDetails.e_id)
    },
    method: 'POST',
    body: JSON.stringify(userDetails)
  })
  if (!response.ok || response.status === 204 ) {
    return response
  }
  return response.json()
}

export async function removeBookmark (userDetails: any) {
  const response = await fetch('/customPortal/removeBmReports', {
    headers: {
      'Content-Type': 'application/json',
      rt: reversestring(userDetails.e_id)
    },
    method: 'POST',
    body: JSON.stringify(userDetails)
  })
  if (!response.ok || response.status === 204 ) {
    return response
  }
  return response.json()
}

export async function fetchBmReports (userDetails: any) {
  const response = await fetch('/customPortal/bmReports', {
    headers: {
      'Content-Type': 'application/json',
      rt: reversestring(userDetails.e_id)
    },
    method: 'POST',
    body: JSON.stringify(userDetails)
  })
  if (!response.ok || response.status === 204 ) {
    return response
  }
  return response.json()
}

export async function fetchfareports (userDetails: any) {
  const response = await fetch('/customPortal/faReports', {
    headers: {
      'Content-Type': 'application/json',
      rt: reversestring(userDetails.e_id)
    },
    method: 'POST',
    body: JSON.stringify(userDetails)
  })
  if (!response.ok || response.status === 204 ) {
    return response
  }
  return response.json()
}

export async function getSlaMissMessage () {
  const response = await fetch('/customPortal/config/slamiss', {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'GET'
  })
  if (!response.ok || response.status === 204 ) {
    return response
  }
  return response.json()
}

export async function getBannerMessage () {
  const response = await fetch('/customPortal/config/bannermsg', {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'GET'
  })
  if (!response.ok || response.status === 204 ) {
    return response
  }
  return response.json()
}

export function makeid (length: number) {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export function reversestring (str: string) {
  const a1 = str.split('').reverse().join('').split('')
  const a2 = makeid(10).split('')
  const a3 = Array(a1.length + a2.length)
  for (let i1 = 0, i2 = 0, i3 = 0; i3 < a3.length;) {
    if (i1 < a1.length) {
      a3[i3++] = a1[i1++]
    }
    if (i2 < a2.length) {
      a3[i3++] = a2[i2++]
    }
  }
  return a3.join('')
}

export async function checkAdminUser (uniqueUser: any) {
  const response = await fetch('/customPortal/isAdmin', {
    headers: {
      em: uniqueUser[0].encUserEmailAddr,
      rt: reversestring(uniqueUser[0].e_id)
    },
    method: 'GET'
  })
  if (!response.ok || response.status === 204 ) {
    return response
  }
  return response.json()
}

export async function deletereport (userDetails: any, em?: string, eid?: string, emailId = 'parag.naik@metlife.com') {
  const response = await fetch('/customPortal/softDelete', {
    headers: {
      'Content-Type': 'application/json',
      em: em || '',
      rt: reversestring(eid || '')
    },
    method: 'POST',
    body: JSON.stringify(userDetails)
  })
  if (!response.ok || response.status === 204 ) {
    return response
  }
  return response.json()
}

export async function downloadreport (userType: string, id: string | number, fileName: string, em?: string, eid?: string) {
  const response = await fetch(`/customPortal/downloadFile/${userType}/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      em: em || '',
      rt: reversestring(eid || '')
    },
    method: 'GET'
  })
  if (response.status === 200) {
    return response.blob()
  }
  return false
}

export async function reportHistoryService (userDetails: any) {
  const response = await fetch('/customPortal/reportHistory', {
    headers: {
      'Content-Type': 'application/json',
      rt: reversestring(userDetails.e_id)
    },
    method: 'POST',
    body: JSON.stringify(userDetails)
  })
  if (!response.ok || response.status === 204 ) {
    return response
  }
  return response.json()
}
